import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { BdcPipeline } from '../components/BdcPipeline';
import { ManagerQueue } from '../components/ManagerQueue';
import BdcAtendimentos from '../components/BdcAtendimentos';
import { BdcDashboard } from '../components/BdcDashboard';

const Bdc = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const leadParam = searchParams.get('lead');
  const isManager = user?.permissions?.includes('assign_bdc_agent') || user?.permissions?.includes('assign_salesperson');
  const [tab, setTab] = useState('pipeline');

  React.useEffect(() => { if (leadParam) setTab('pipeline'); }, [leadParam]);

  const tabs = [
    { key: 'pipeline', label: 'Pipeline de Leads' },
    ...(isManager ? [{ key: 'queue', label: 'Manager Queue' }, { key: 'dashboard', label: 'Dashboard' }] : []),
    { key: 'atendimentos', label: 'Atendimentos' },
  ];

  return (
    <div className="space-y-5">
      <div className="ent-tabs w-full">
        {tabs.map((t) => (
          <button key={t.key} data-testid={`bdc-tab-${t.key}`} onClick={() => setTab(t.key)} className={`ent-tab ${tab === t.key ? 'ent-tab-active' : ''}`}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'pipeline' && <BdcPipeline initialLeadId={leadParam} />}
      {tab === 'queue' && isManager && <ManagerQueue />}
      {tab === 'dashboard' && isManager && <BdcDashboard />}
      {tab === 'atendimentos' && <BdcAtendimentos />}
    </div>
  );
};

export default Bdc;
